import { format } from 'date-fns';

const czechShortDays = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];

/**
 * Formátuje datum jako např. "Po 17.07.2025 16:45".
 * @param date Datum nebo hodnota, kterou lze převést na Date.
 * @returns Formátovaný řetězec s krátkým dnem v týdnu.
 */
export function formatDateWithShortWeekday(date: Date | string | number): string {
  const d = new Date(date);
  const weekday = czechShortDays[d.getDay()];
  return `${weekday} ${format(d, 'dd.MM.yyyy HH:mm')}`;
}
